import axios from 'axios'
import { config } from '../shared/app.config'

const RESOURCE_NAME = '/epis'

export default {
  edit(id, epi) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/${id}`, epi)
  },
  clone(idepi, idlocation, quantity) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/duplicate`, {
      epi_id: idepi,
      location_id: idlocation,
      quantity,
    })
  },
  create(epi) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}`, epi)
  },
  getEpi(id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME}/${id}`)
  },
  delete(id) {
    return axios.delete(`${config.webApiBase + RESOURCE_NAME}/${id}`)
  },
  getList(
    client = '',
    page,
    per_page,
    search,
    category_id = "",
    status = "",
    vida_util = "",
    prox_revision = "",
    product = "",
    user = "",
    date_ini,
    date_fin,
    location_id,
    num_albaran,
  ) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/list`, {
      id_client: client,
      page,
      per_page,
      search,
      category_id,
      status,
      vida_util,
      prox_revision,
      product_id: product,
      user_id: user,
      date_ini,
      date_fin,
      location_id,
      num_albaran,
    })
  },
  getListSummary(product_id) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/summary`, {
      product_id,
    })
  },
}
